var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-news-page" },
    [
      _c("h2", { staticClass: "p-hdg-centered" }, [_vm._v("お知らせ一覧")]),
      _vm._v(" "),
      _c("div", { staticClass: "p-news-sort", attrs: { id: "newsTab" } }, [
        _c("div", { staticClass: "shop container" }, [_c("SelectShop")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "calendar container" },
          [_c("SelectCalender")],
          1
        )
      ]),
      _vm._v(" "),
      _c("NewsList"),
      _vm._v(" "),
      _c("Pager")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }